export const endpointURL = 'https://murmuring-everglades-73384.herokuapp.com';
export const strathfieldCouncilRules =
  'https://s3-ap-southeast-2.amazonaws.com/shared-drupal-s3fs/master-test/fapub_pdf/STRATHFIELD/Strathfield%20DCP%202005%20-%20as%20amended%2028%20Jul%202015.pdf';
